import { Action, Selector, State, StateContext } from "@ngxs/store";
import { BlockUIStateModel } from "./block-ui-model";
import { Injectable } from "@angular/core";
import { BlockUI } from "./block-ui-actions";

@State<BlockUIStateModel>
(
    {
        name: "blockUi",
        defaults: 
        {
            uiBlocked: false
        }
    }
)

  @Injectable()
  export class BlockUIState
  {

    constructor
    (
        
    )
    {
    }


    @Selector()
    static uiBlocked(state: BlockUIStateModel)
    {
        return state.uiBlocked;
    }

    @Action([BlockUI.BlockUI])
    blockUi(ctx:StateContext<BlockUIStateModel>)
    {
        const state = ctx.getState();
        ctx.setState({...state, uiBlocked: true});
    }

    @Action([BlockUI.UnBlockUI])
    unblockUi(ctx:StateContext<BlockUIStateModel>)
    {
        const state = ctx.getState();
        ctx.setState({...state, uiBlocked: false});
    }
  }